import React from "react";

const InputSearch = ({ item, onChange }) => {
  return (
    <div>
      <input
        style={{ fontSize: "12px" }}
        placeholder="جستجو ..."
        className="searchbox"
        onChange={onChange}
      />
    </div>
  );
};

export default InputSearch;
